module.exports = __webpack_public_path__ + "img/banner.b5319854.png";